const productsSettingsLinks: any[] = [];
export default productsSettingsLinks;
